// require('fslightbox');

if (document.querySelector('[data-fslightbox]') || document.querySelector('.wp-block-gallery') || document.querySelector('.gallery-item')) {
	setTimeout(() => {
		(async () => {
			const fslighbox = await import('fslightbox')

			const galleries = document.querySelectorAll('.wp-block-gallery');
			galleries.forEach(gallery => {
				let links = gallery.querySelectorAll('a');
		
				links.forEach(link => {
					link.setAttribute('data-fslightbox', 'gallery');
					link.setAttribute('aria-hidden', true);
					link.setAttribute('tabindex', -1);
				});
			});

			const tinyMCEGalleryItems =  document.querySelectorAll('.gallery-item');
			let tinyMCEGalleries = [];
			tinyMCEGalleryItems.forEach(item => {
				let parentEl = item.parentElement;
				let tinyMCEGalleryIndex = (tinyMCEGalleries.includes(parentEl)) ? tinyMCEGalleries.indexOf(parentEl) : tinyMCEGalleries.push(parentEl) - 1;
				item.setAttribute('data-fslightbox', `gallery-${tinyMCEGalleryIndex}`);
				item.setAttribute('aria-hidden', true);
				item.setAttribute('tabindex', -1);
			});

			refreshFsLightbox();
		})();
	}, 500)
}
